import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.createFolderRequested]: setRequestStateToPending,
    [events.createFolderSucceeded]: setRequestStateToSuccess,
    [events.createFolderFailed]: setRequestStateToFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
